<script setup lang="ts">
import Typography from '@components/Typography.vue';

interface MenuItemProps {
  isActive?: boolean,
  isExpanded?: boolean,
  hasPin?: boolean,
}

const {
  isActive = false,
  isExpanded = false,
  hasPin = false,
} = defineProps<MenuItemProps>();
</script>

<template>
  <div
    class="menu-item"
    :class="[
      isActive ? 'bg-blue-lightest' : 'hover:bg-blue-lightest',
      'rounded-lg',
      'h-12',
      isExpanded ? 'w-full' : 'w-14',
      'px-4',
      'flex items-center gap-2',
      isExpanded ? 'justify-start' : 'justify-center',
      'select-none',
      'cursor-pointer',
    ]"
  >
    <div
      class="relative flex shrink-0"
      :class=" { 'justify-center': isExpanded }"
    >
      <slot name="icon" />

      <span
        v-if="hasPin"
        class="menu-item__pin border border-solid border-white bg-red"
        :class="[
          'absolute right-0 top-0',
          'rounded-full',
          'size-3',
        ]"
      />
    </div>

    <Typography
      v-if="isExpanded"
      :variant="isActive ? 'body-small-bold' : 'body-small'"
      :class="[ 'grow', 'whitespace-nowrap' ]"
    >
      <slot name="text" />
    </Typography>
  </div>
</template>
